import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getIdentidadeGenero, cadastrarIdentidadeGenero, alterarIdentidadeGenero, excluirIdentidadeGenero } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var IdentidadesGeneroEditar = function () {
    var services = {
        getItem: getIdentidadeGenero,
        cadastrarItem: cadastrarIdentidadeGenero,
        alterarItem: alterarIdentidadeGenero,
        excluirItem: excluirIdentidadeGenero,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.IDENTIDADES_GENERO, paginaPermissao: FUNCIONALIDADES.IDENTIDADES_GENERO, rota: ROUTES.IDENTIDADES_GENERO, services: services });
};
export default IdentidadesGeneroEditar;
